import React from 'react';
import { FormControl, InputLabel, TextField } from '@mui/material';
import { alpha } from '@mui/material/styles';

function FilterTextInput({value, onChange, sx, placeholder }) {
    return (
        <FormControl variant="outlined" color="primary" size="small" sx={{ minWidth: 200, ...sx }}>
            <InputLabel
                shrink
                sx={{
                    fontSize: '13px',
                    fontWeight: 700,
                    top: '-6px',
                    left: '-4px',
                    color: alpha('#3b3c3b', 0.6),
                }}
            >
            </InputLabel>
            <TextField
                variant="outlined"
                size="small"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </FormControl>
    );
}

export default FilterTextInput;
